import type { BillingAddress } from '../../billing-address/libs/type'
import type { ShippingAddress } from '../../shipping-address/libs/type'

export type PaymentMethod = {
  description: string
  errors: unknown[]
  hasFields: boolean
  id: PaymentMethodEnum
  instructions: null | string
  methodDescription: string
  methodTitle: string
  title: string
}

export enum PaymentMethodEnum {
  BACS = 'bacs',
  OMISE = 'omise',
  OMISE_INTERNET_BANKING = 'omise_internetbanking',
  OMISE_PROMPTPAY = 'omise_promptpay',
}

export type CheckoutFormValues = {
  acceptTermsAndConditions: boolean
  attributions: {
    referrer: string
    sessionCount: string
    sessionEntry: string
    sessionPages: string
    sessionStartTime: string
    sourceType: string
    userAgent: string
    utmCampaign: string
    utmContent: string
    utmId: string
    utmMedium: string
    utmSource: string
    utmTerm: string
  }
  billingAddress?: Omit<BillingAddress, 'display' | 'id'>
  email?: string
  enableOrderNotes: boolean
  enableRequestTaxInvoice: boolean
  omiseToken?: string
  orderNotes: string
  paymentMethod: string
  shippingAddress?: Omit<
    ShippingAddress,
    'display' | 'id' | 'isDefault' | 'label'
  >
}

export type BankAccount = {
  accountName: string
  accountNumber: string
  bankLogo: string
  bankName: string
}
